import DeleteIcon from "@mui/icons-material/Delete";
import { Box, IconButton, Paper, Stack } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FileUploadEditing from "../FileUploadEditing";
import useGetCategoreis from "../hooks/useGetCategoreis";
import {
  CLINIC_CATEGORIES_DROPDOWN,
  CLINIC_CATEGORIES_MASTER,
} from "../../../../enums/ApiPaths";
import useUser from "../../../../hooks/useUser";
import { useParams } from "react-router-dom";
import FileIcon from "../../../display/FileIcon";
import { getFileExtension } from "../utils/FileUploadFunctions";

export default function EditFilesStep({ selectedFiles, onFileDelete }) {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { fields, remove } = useFieldArray({ name: "files", control });
  const { roles, currentClinic } = useUser();
  const { ownerId } = useParams();
  function handleRemove(index, fileToRemove) {
    remove(index);
    onFileDelete(fileToRemove);
  }

  const url = roles?.master
    ? CLINIC_CATEGORIES_MASTER
    : CLINIC_CATEGORIES_DROPDOWN;

  const clinicId = currentClinic?.id ? Number(currentClinic.id) : null;
  const id = roles?.master ? Number(ownerId) : Number(clinicId);

  const categories = useGetCategoreis(url, id, id);

  return (
    <div>
      <Stack spacing={1.5}>
        {fields.map((field, index) => {
          const file = selectedFiles[index];

          return (
            <Paper
              key={field.id}
              variant="outlined"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: { xs: 1, sm: 2 },
                py: 0.5,
                borderRadius: 3,
              }}
            >
              <Box
                sx={{
                  display: { xs: "none", sm: "flex" },
                  flexShrink: 0,
                  "& svg": { width: 28, height: 28 },
                }}
              >
                <FileIcon fileExtension={getFileExtension(file?.name)} />
              </Box>
              <FileUploadEditing
                file={file}
                index={index}
                categories={categories}
              />
              <IconButton
                onClick={() => handleRemove(index, file)}
                aria-label={t("Delete")}
                title={t("Delete")}
                color="error"
              >
                <DeleteIcon />
              </IconButton>
            </Paper>
          );
        })}
      </Stack>
    </div>
  );
}
